import { useRouter } from "lib/router"
import { getLocale } from "lib/apolloClient"
import { siteUrl } from "./getSiteUrl"
import { removeTrailingSlash } from "./removeTrailingSlash"

export const usePageUrl = (): string => {
  const router = useRouter()
  const locale = getLocale()

  const pageUrl = `${siteUrl}${locale === "en-US" ? "/us" : ""}${
    router?.asPath
  }`

  return removeTrailingSlash(pageUrl)
}
